import { parseMoneyInput } from '@nsb/core';
/**
 * What leaving the field commits: the amount typed, blank for a field left
 * empty, and nothing at all for words it cannot read as money ("12k", "1200
 * ea"), which go back to what was there: a typo never blanks a price.
 */
export function committed(text: string, value: number | null): { commit: boolean; value: number | null } {
  const next = parseMoneyInput(text);
  if (next === null && text.trim() !== '') return { commit: false, value };
  return { commit: next !== value, value: next };
}
